"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AttachmentGeneralHandler", {
    enumerable: true,
    get: function() {
        return AttachmentGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _computed = require("~/db/field-handler/handlers/computed");
const _catchError = require("~/helpers/catchError");
const _dbHelpers = require("~/helpers/dbHelpers");
const _extractProps = require("~/helpers/extractProps");
const _models = require("~/models");
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
let AttachmentGeneralHandler = class AttachmentGeneralHandler extends _computed.ComputedFieldHandler {
    async parseUserInput(params) {
        let oldValue = params.oldData && (0, _dbHelpers.dataWrapper)(params.oldData).getByColumnNameTitleOrId(params.column);
        oldValue = oldValue || '[]';
        let oldValueMap;
        let value = params.value;
        if (!value) {
            return value;
        }
        const throwError = (reason)=>{
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt,
                reason
            });
        };
        try {
            if (typeof value === 'string') {
                value = JSON.parse(value);
            } else if (!Array.isArray(value)) {
                // do not throw error, but set it as empty array
                value = [];
            }
            if (typeof value === 'string' || !Array.isArray(value)) {
                throwError('Invalid format for attachment field');
            }
        } catch (e) {
            // do not throw error, but set it as empty array
            value = [];
        }
        try {
            if (typeof oldValue === 'string') {
                oldValue = JSON.parse(oldValue);
            }
            oldValueMap = new Map(oldValue.map((val)=>[
                    val.id,
                    val
                ]));
        } catch (e) {
            // do not throw error, but set it as empty map
            oldValueMap = new Map();
        }
        let tempIndex = 1;
        // Confirm that all urls are valid urls
        for (const attachment of value != null ? value : []){
            if (attachment.id) {
                const oldAttachmentRow = oldValueMap.get(attachment.id);
                if (!oldAttachmentRow) {
                    throwError(`Attachment id ${attachment.id} not exists on old data`);
                }
                // if id exists, persist old value
                Object.assign(attachment, oldAttachmentRow);
            } else {
                attachment.id = 'temp_' + tempIndex++;
            }
        }
        const { removed } = (0, _nocodbsdk.arrDetailedDiff)(Array.from(oldValueMap.keys()), value.map((k)=>k.id));
        if (removed.length > 0) {
            await _models.FileReference.delete(params.options.context, removed);
        }
        await (0, _attachmentHelpers.validateNumberOfFilesInCell)(params.options.context, value.length, params.column);
        return {
            value: value.map((attr)=>{
                return attr.id.startsWith('temp_') ? {
                    id: attr.id,
                    url: attr.url,
                    status: 'uploading'
                } : (0, _extractProps.extractProps)(attr, [
                    'id',
                    'url',
                    'path',
                    'title',
                    'mimetype',
                    'size',
                    'icon',
                    'width',
                    'height'
                ]);
            })
        };
    }
};
